module.exports = __webpack_public_path__ + "img/stylist_setting.aabc7bb5.svg";